import AppRouter from "./Router/Router";
import "./App.css";

function App() {
  console.warn = () => {};
  return (
    <>
      <AppRouter />
    </>
  );
}

export default App;
